import React, { Component } from 'react';
import { message } from 'antd';
import { querySaveCustom } from '@api/crm/custom';
import FormEdit from './FormEdit';
import FormProEdit from './FormProEdit';

class Edit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customInfo: {},
      page: 1,
      custom: {},
    };
  }

  saveBase = custom => {
    this.setState({
      custom,
      page: 2,
    });
  };

  handSubmit = projects => {
    const context = this;
    const { custom, customInfo } = this.state;
    if (customInfo.uuid) {
      custom.uuid = customInfo.uuid;
    }
    custom.projects = projects;
    querySaveCustom(custom).then(res => {
      if (res.statusCode === 200) {
        message.success('保存成功');
        context.props.router.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  changePage = page => {
    this.setState({
      page,
    });
  };

  render() {
    const { customInfo, page } = this.state;
    const style1 = {};
    const style2 = {};
    if (page === 1) {
      style1.backgroundColor = '#108ee9';
      style1.color = '#fff';
    } else {
      style2.backgroundColor = '#108ee9';
      style2.color = '#fff';
    }
    const projects = customInfo.projects ? customInfo.projects : [{}];
    return (
      <div>
        <div className="custom-step">
          <p>
            <span style={style1}>1</span>基本信息
          </p>
          <div className="border" />
          <p>
            <span style={style2}>2</span>项目信息
          </p>
        </div>
        {page === 1 ? (
          <FormEdit data={customInfo} changePage={this.changePage} saveBase={this.saveBase} />
        ) : (
          <FormProEdit data={projects} changePage={this.changePage} handSubmit={this.handSubmit} />
        )}
      </div>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/components/custom/base/PageAdd.js